var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBatModern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 744.469,
    height: 252.854,
    viewBox: "0 0 196.974 66.901",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    width: 1.049,
    height: 1.143,
    x: -0.024,
    y: -0.072
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: "2 2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    transform: "translate(-6.817 -110.18)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "batLogoPath",
    fill: "#000",
    d: "M6.817 110.305l66.132-.125c1.773 13.632 11.775 14.676 21.923 15.497 2.216.326 2.741-1.039 3.213-2.457l1.89-10.583 1.767 7.192c2.131-.492 4.925-.421 6.926-.01l1.701-7.182 2.079 10.772c.181 1.915 1.425 2.502 3.024 2.646 12.285-.287 20.634-4.338 21.355-15.686l66.964-.064c-22.06 8.592-36.804 19.88-30.3 38.996-27.654-3.149-59.869-.311-68.414 27.78-6.79-30.87-50.334-29.63-68.602-28.158 5.04-13.726.412-26.899-29.658-38.618z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatModern);
export default __webpack_public_path__ + "static/media/batModern.bc98f8e4d636b35ee444114507d0cbde.svg";
export { ForwardRef as ReactComponent };